export default "__VITE_ASSET__CHMAARD2__"